module.exports = __webpack_public_path__ + "static/media/IBMPlexSans-Regular.bb07700d.woff2";